module.exports = __webpack_public_path__ + "media/packs/compcalc/components/icons/about-f33471d219819a28cdb894b6e178eda6.png";